module.exports = __webpack_public_path__ + "static/media/IMG_5953.28284e4f.webp";